<template class="w-100">
    <div v-if="waitingCustomers && waitingCustomers?.quantity != 0" :class="'alert alert__card d-flex justify-content-between align-items-center w-100 ' + this.colorClass" role="alert">
        <div><b> Aguardando</b></div>
        <div>
            {{ waitingCustomers.quantity }}
        </div>
        <a :href="queue.url" target="_blank" class="btn btn-danger btn-sm">
        Let's Rock
        </a>
    </div>
</template>
<script>

import { updateTime } from '@/configs/general';
import { getColorClass } from '@/services/utils';
import { queuesColors} from '@/configs/colors'
import { waitingService } from '@/services/backend/ApiService';

export default {
    props: {
        queue: {
            type: Object,
            default: () => ({}) 
        },
        waiting: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            waitingCustomers: 0,
            intervalId: null,
            colorClass: '',
            isWithinPolicy: true,
            isFetching: false,
        };
    },
    watch: {
        'waitingCustomers.quantity': {
            handler(newVal) {
                if (typeof newVal === 'number') {
                    this.$emit('update:waiting', newVal);
                }
            },
            immediate: true
        }
    },
    async mounted() {
        this.startFetchingWaitingCustomers(); 
    },
    beforeUnmount() {
        clearInterval(this.intervalId); 
    },
    methods: {
        async fetchWaitingCustomers() {
            if (this.isFetching) return;
            this.isFetching = true;
            try {
                const filter = {client: this.queue.client, order: { createdAt: 'desc'}, limit: 1};
                this.waitingCustomers = (await waitingService.findAll(filter))[0];
                if(!this.waitingCustomers) return;
                this.colorClass = getColorClass(this.waitingCustomers.quantity, queuesColors);   
                // Emite sempre que buscar
                this.$emit('update:waiting', this.waitingCustomers.quantity);
            } catch (error) {
                console.error("Erro ao buscar clientes:", error);
            } finally {
                this.isFetching = false;
            }
        },
        startFetchingWaitingCustomers() {
            this.fetchWaitingCustomers(); 
            this.intervalId = setInterval(() => {
                this.fetchWaitingCustomers();
            }, updateTime);
        }
    }
}
</script>

<style scoped></style>